import { useQuery } from 'react-query'
import API from '.'

const ENDPOINT = '/api/accounts'
const QUERY_KEY = 'accounts'

export const serializeQuery = (endpoint, query) =>
  endpoint +
  '?' +
  Object.entries(query)
    .map((entry) =>
      entry
        .map((value) =>
          Array.isArray(value) ? value.map(encodeURIComponent).join(',') : encodeURIComponent(value)
        )
        .join('=')
    )
    .join('&')

export const useGetAccountsByHTG = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'htg', query],
    async () => (await API.get(serializeQuery(`${ENDPOINT}/htg`, query))).data,
    config
  )

export const useGetLinkedCompanies = (config = {}) =>
  useQuery(
    [QUERY_KEY, 'linked-companies'],
    async () => (await API.get(`${ENDPOINT}/linked-companies`)).data,
    config
  )

export const useGetSalesIds = (config = {}) =>
  useQuery(
    [QUERY_KEY, 'salesids'],
    async () => (await API.get(`${ENDPOINT}/salesIds`)).data,
    config
  )

export const useGetAccounts = (params = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, 'list', params],
    async () => {
      if (params.userCompanies) {
        return params.userCompanies
          .filter(({ htg }) => htg === params.htgCompany)
          .map((company) => ({
            htgCompany: company.htg,
            companyAccountId: company.customerId,
            companyName: company.name
          }))
      }
      return (await API.get(`${ENDPOINT}`, { params })).data
    },
    config
  )
